import { useEffect, useState } from "react";
import { connect } from "react-redux";
// import { ToastContainer } from "react-toastify";
import MeetingListComponent from "../../../components/Meetings/Meeting";
// import { errorToast, successToast } from "../../helper/notification";
import { mapDispatchToProps } from "../../../store/helpers/mapDispatch";
import { mapStateToProps } from "../../../store/helpers/mapState";

const MeetingManagement = (props) => {
  const {
    selectedFolder,
    GetAllMeetings,
    meetings,
    location,
    loggedUser,
    GetAllInvitedIn,
    invitedIn,
    settings,
    MarkAsRead,
    SetSelectedMenu,
    systemSettings
  } = props;
  const [notificationList, setNotificationsList] = useState([]);

  useEffect(() => GetAllMeetings("All"), [GetAllMeetings]);
  useEffect(() => GetAllInvitedIn("All"), [GetAllInvitedIn]);

  useEffect(()=>{
    SetSelectedMenu({
      menu:"meeting",
      title:"Meeting Management"
    })
  },[]);

  return (
    <div className="w-full mb-12 px-4">
      <MeetingListComponent
        selectedFolder={selectedFolder}
        meetings={meetings}
        GetAllMeetings={GetAllMeetings}
        GetAllInvitedIn={GetAllInvitedIn}
        location={location}
        loggedUser={loggedUser}
        invitedIn={invitedIn}
        settings={settings}
        notification={notificationList}
        MarkAsRead={MarkAsRead}
        systemSettings={systemSettings}
      />
     </div>
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(MeetingManagement);
